import { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Spinner } from "@/components/Kit";
import { playSfx } from "@/lib/sound";
import { Wrench, Plus, Activity } from "lucide-react";

export default function AssemblyBay() {
  const navigate = useNavigate();
  const { refreshPet, patchUser, user } = useOutletContext();
  const [busy, setBusy] = useState(false);

  const diagnostic = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/station/diagnostic");
      patchUser({ credits: data.credits }); playSfx("coin");
      toast.success(data.message);
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="assembly-bay-page">
      <span className="label-cap text-primary flex items-center gap-2"><Wrench className="w-4 h-4" /> Unit-01 // The Fore-Bot</span>
      <h1 className="text-4xl font-black tracking-tighter mt-2 mb-6 font-head">Assembly Bay</h1>
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="panel-glow p-6 hud-corner">
          <Plus className="w-8 h-8 text-primary mb-3" />
          <h3 className="font-head font-bold text-lg">Fabricate New Bot</h3>
          <p className="text-sm text-muted-foreground mb-4">Assemble a new robot from the Modular Matrix. You may care for up to 4 units.</p>
          <button data-testid="fabricate-btn" onClick={() => navigate("/app/create")} className="btn-primary w-full">Open Assembly Matrix</button>
        </div>
        <div className="panel p-6">
          <Activity className="w-8 h-8 text-secondary mb-3" />
          <h3 className="font-head font-bold text-lg">Daily Diagnostic Check</h3>
          <p className="text-sm text-muted-foreground mb-4">Unit-01 runs a free diagnostic once per day and slips you some Credits.</p>
          <button data-testid="diagnostic-btn" onClick={diagnostic} disabled={busy} className="btn-secondary w-full">
            {busy ? <Spinner className="w-4 h-4" /> : "Run Diagnostic"}
          </button>
        </div>
      </div>
    </div>
  );
}
